<template>
  <div id="footer">
    <div id="b_plankPictureView" class="fullWidthElement" >
      <img src="./../../public/img/gerüstbohle-d.jpeg" style="opacity: 0.5" alt="gerüstbohle" width="100%" />
    </div>
    <div id="left">
      <img src="./../../public/icons/logo.svg" height="150px"/>
      <div id="links">
        <!-- <div>
          <router-link to="/impressum">
              <span style="color:var(--mainColor); text-decoration: none;">Impressum</span>
          </router-link>
        </div>
        <div>
          <router-link to="/datasecurity">
              <span style="color:var(--mainColor); text-decoration: none;">Datenschutz</span>
          </router-link>
        </div>
        <div>
          <router-link to="/faq">
              <span style="color:var(--mainColor); text-decoration: none;">FAQs</span>
          </router-link>
        </div> -->
      </div>
    </div>
    <div id="right">
      <p style="color:var(--mainColor); text-align: left;">
        <b>Du hast weitere Fragen?</b><br/>
        kontaktiere uns gerne:
        <br/>
        E-Mail:
        <a href="mailto:info@rho-17.de?subject=Hallo,%20ich%20habe%20eine%20Frage" style="color:var(--mainColor) !important; text-decoration: none;">
          info@rho-17.de
        </a><br/>
        Telefon:
        <a href="tel:+4915154332276" style="color:var(--mainColor) !important; text-decoration: none;">0151 543 322 76</a>
<br/><br/>
        © 2022 rho 17, All Rights Reserved
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  props: [],
  components: {
  },
  data() {
    return{
    }
   },
   mounted (){
   },
   computed: {
     getText(){
       return this.$store.getters.getText.main;
     }
   },
   watch: {
   },
   methods: {
   }
}
</script>

<style scoped>
#links{
  height: 20px;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
#left{
  position: absolute;
  display: grid;
  grid-template-rows: 170px 1fr;
  width: 300px;
  bottom: 10px;
  left: 30px;
}
#right{
  position: absolute;
  bottom: 10px;
  right: 30px;
  width: 300px;
}
#b_plankPictureView{
  /* margin-top: 90px; */
  height: 190px;
}
#footer{
  position: relative;
  height: 240px;
  padding-top: 20px;
}

</style>
